import { ContinuousRouteObject } from '@ng-cloud/badger-core/map/objects/continuous-route-object';
import * as _ from 'lodash';
import { Pose } from '../../models/pose';
import { MapGrouping } from './map-grouping';
import { Layers } from './map-layer';

@Layers([
  { name: 'route', zIndex: 2 }
])
export class ContinuousRouteGrouping extends MapGrouping<Pose[], ContinuousRouteObject> {

  createObject(poses: Pose[]): ContinuousRouteObject {
    const points = _.map(poses, pose => this.storeMap.poseToPixels(pose));

    return new ContinuousRouteObject(points, this.options);
  }
}
